module.exports = __webpack_public_path__ + "img/jiandan.ec47342c.png";